import { useWatch } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useSTContext } from '../table/SmartTableContext';
import { toFilterCondition } from './helpers';
const DEBOUNCE_MS = 400;
export function useFilterPreviewCount(control, open) {
    const context = useSTContext();
    const [count, setCount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const watchedValues = useWatch({ control });
    const debouncedFetch = useDebouncedCallback(async () => {
        const condition = toFilterCondition(watchedValues, context.rowFilterCondition);
        if (!condition) {
            setCount(null);
            return;
        }
        setIsLoading(true);
        try {
            const total = context.api.filterCountApiCall
                ? (await context.api.filterCountApiCall(condition)).total
                : (await context.api.rowsApiCall(condition, context.sorting, { offset: 0, pageSize: 1 })).total;
            setCount(total);
        }
        catch {
            setCount(null);
        }
        finally {
            setIsLoading(false);
        }
    }, DEBOUNCE_MS);
    useEffect(() => {
        if (!open) {
            setCount(null);
            debouncedFetch.cancel();
            return;
        }
        const condition = toFilterCondition(watchedValues, context.rowFilterCondition);
        if (!condition) {
            setCount(null);
            return;
        }
        debouncedFetch();
        return () => debouncedFetch.cancel();
    }, [open, watchedValues, context.rowFilterCondition, debouncedFetch]);
    return { count, isLoading };
}
//# sourceMappingURL=useFilterPreviewCount.js.map